if (!customElements.get('aqsa-hero-slider')) {
  customElements.define(
    'aqsa-hero-slider',
    class AqsaHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.aqsa-hero-slide'));
        this.dots = Array.from(this.querySelectorAll('.aqsa-hero-dot'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.delay = Number(this.dataset.delay) || 4000;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot) => dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.slideTo));
          this.restart();
        }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.aqsa-hero-slide');
          if (slide) this.show(Number(slide.dataset.slideIndex));
          this.stop();
        });
        this.start();
      }

      disconnectedCallback() { this.stop(); }

      show(nextIndex) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      }

      start() {
        if (this.reduceMotion || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }
  );
}
